'use strict';

angular.module('ufcw')
  .controller('FramePageController', function ($log,$rootScope, $location, $sce) {
    var vm = this;

    $rootScope.headLander = false;
    
    var url = $location.search().url; 

    vm.trustedUrl = ''; 
    vm.openInFrame = function(url) {
      vm.trustedUrl = $sce.trustAsResourceUrl(url);
    };

    vm.openInFrame(url);

  });